// extracted by mini-css-extract-plugin
export default {"articleTitle":"certificateCharge_articleTitle__3grzy","row":"certificateCharge_row__zWMf5"};